import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as LoadActions from '../_actions/load';
import { Load } from '../_models';

export interface LoadState extends EntityState<Load> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Load> = createEntityAdapter<Load>();

const initialState: LoadState = adapter.getInitialState({
  loading: false,
  error: null,
});

const loadReducer = createReducer(
  initialState,

  on(LoadActions.loadLoads, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LoadActions.loadLoadsSuccess, (state, { loads }) =>
    adapter.setAll(loads, { ...state, loading: false })
  ),

  on(LoadActions.loadLoadsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LoadActions.addLoadSuccess, (state, { load }) => adapter.addOne(load, state)),

  on(LoadActions.updateLoadSuccess, (state, { load }) => adapter.upsertOne(load, state)),

  on(LoadActions.deleteLoadSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    LoadActions.addLoadFailure,
    LoadActions.updateLoadFailure,
    LoadActions.deleteLoadFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: LoadState | undefined, action: Action) {
  return loadReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
